import { getTagList, getTagLevel, getCreativeMdmList, getEnumList, getAuditMdmList, getBusinessUnitList } from '@/pages/agency/assets/creative-material/api';
import { getComponentUnitList } from '@/pages/agency/creative-component/preview-list/api';
import { getOperatorList, getSubordinateList } from '@/api/operator/cgi/smb/account/gdt';
import globalStore from '@/stores';
import { REGEXP } from '@/constants/regexp';
import { FILTER_TEMPLATE } from './constants';

const getOperatorConfig = (roleList: string[]) => {
  return {
    searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
    fetchData: (params: any) => getOperatorList({
      data: {
        ...params,
        // agency_uid: globalStore.account.agency_uid, // 主体维度，不能指定服务商
        operator_role_list: roleList, // ['AGENCYOPERATORROLE_AGENCY_DESIGNER', 'AGENCYOPERATORROLE_AGENT_OPERATOR'],
        page: 1,
        page_size: 100,
      },
    }, {
      needAgencyUid: false,
      isCache: true,
    }),
    convertData: (res: any) => {
      const { code, data = {} } = res;
      if (code === 0) {
        const { list = [] } = data;
        return list.map((v: any) => ({
          ...v,
          label: v.operator_name,
          value: v.user_id,
        }));
      }
      return [];
    },
    search: true,
    getSearchParams: (keywords: any) => ({ filter: keywords }),
  };
};

const getOrbacOperatorConfig = (roleList: number[]) => {
  return {
    searchFields: ['label', 'value'],
    fetchData: (params: any) => getSubordinateList({
      ...params,
      company_id: globalStore.account.company_id,
      user_id: globalStore.account.user_id,
      subordinate_role_ids: roleList, // [108, 116],
      page: 1,
      page_size: 100,
    }),
    convertData: (res: any) => {
      const { code, data = {} } = res;
      if (code === 0) {
        const { list = [] } = data;
        return list.map((v: any) => ({
          ...v,
          label: v.name,
          value: v.user_id,
        }));
      }
      return [];
    },
    search: true,
    getSearchParams: (keywords: any) => (/^\d+$/.test(keywords) ? { user_id: Number(keywords) } : { fuzzy_subordinate_name: keywords }),
  };
};

export default {
  label_name: {
    name: 'label_name',
    title: '标签名称',
    type: 'search',
    config: {
      placeholder: '请输入标签名称',
    },
  },
  level_id: {
    name: 'level_id',
    title: '标签类目',
    type: 'select-tree',
    config: {
      data: [],
      fetchData: () => getTagLevel(),
      convertData: (res: any) => {
        return res?.data || [];
      },
      valueType: 'child',
      selectTarget: 'child',
      // showParentNodeLabel: false,
      fieldNames: {
        labelFieldName: 'level_name',
        valueFieldName: 'level_id',
        nodeFieldName: 'sub_level',
      },
      placeholder: '请选择标签类目',
    },
  },
  media_id_list: {
    name: 'media_id_list',
    title: '素材ID',
    ...FILTER_TEMPLATE.numArray,
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.replace(/\s+/g, '').split(',')
        .filter((v: string) => v),
    }),
  },
  media_name: {
    name: 'media_name',
    title: '素材名称',
    type: 'search',
    config: {
      placeholder: '请输入素材名称',
    },
  },
  media_source_list: {
    name: 'media_source_list',
    title: '素材来源',
    type: 'select',
    config: {
      placeholder: '请选择素材来源',
      data: [],
      // fetchData: (params: any) => getEnumList(params),
      // convertData: (res: any) => {
      //   return [];
      // },
    },
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.split(','),
    }),
  },
  media_size: {
    name: 'media_size',
    title: '素材尺寸',
    type: 'select',
    config: {
      placeholder: '请选择素材尺寸',
      fetchData: (params: any) => getEnumList(params),
      convertData: (res: any) => {
        return (res?.data?.ratio_list || []).map((v: any) => ({
          value: `${v.width},${v.height}`,
          label: v.desc,
        }));
      },
    },
    convertValue: (value: string) => {
      const [width, height] = value?.split(',') || [];
      return width && height ? { width: Number(width), height: Number(height) } : {};
    },
  },
  media_duration: {
    name: 'media_duration',
    title: '素材时长',
    type: 'select',
    config: {
      placeholder: '请选择素材时长',
      fetchData: (params: any) => getEnumList(params),
      convertData: (res: any) => {
        return (res?.data?.duration_list || []).map((v: any) => ({
          value: `${v.min_second},${v.max_second}`,
          label: v.desc,
        }));
      },
    },
    convertValue: (value: string) => {
      const [min, max] = value?.split(',') || [];
      return min && max ? { min_second: Number(min), max_second: Number(max) } : {};
    },
  },
  label_id_list: {
    name: 'label_id_list',
    title: '素材标签',
    type: 'select-tree',
    config: {
      multiple: true,
      placeholder: '请选择素材标签',
      data: [
      ],
      fetchData: () => getTagList({
        data: {
          page: 1,
          page_size: 9999,
        },
      }),
      convertData: (res: any) => {
        return res?.data?.list || [];
      },
      fieldNames: {
        labelFieldName: 'label_name',
        valueFieldName: 'label_id',
      },
    },
  },
  designer: {
    title: '所属员工',
    name: 'user_id_list',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      placeholder: '请选择所属员工',
      ...getOperatorConfig(['AGENCYOPERATORROLE_AGENCY_DESIGNER']),
    },
  },
  designer_orbac: {
    title: '所属员工',
    name: 'user_id_list',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      placeholder: '请选择所属员工',
      ...getOrbacOperatorConfig([116]),
    },
  },
  designer_operator: {
    title: '所属员工',
    name: 'user_id_list',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      placeholder: '请选择所属员工',
      ...getOperatorConfig(['AGENCYOPERATORROLE_AGENCY_DESIGNER', 'AGENCYOPERATORROLE_AGENT_OPERATOR']),
    },
  },
  designer_operator_orbac: {
    title: '所属员工',
    name: 'user_id_list',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      placeholder: '请选择所属员工',
      ...getOrbacOperatorConfig([108, 116]),
    },
  },
  business_unit_id_list: {
    title: '所属业务单元',
    name: 'business_unit_id_list',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择所属业务单元',
      fetchData: (params: any) => getBusinessUnitList({
        ...params,
        page: 1,
        page_size: 50,
      }),
      convertData: (res: any) => {
        return (res?.data?.list || []).map((v: any) => ({
          label: `${v.business_unit_name}(${v.business_unit_id})`,
          value: v.business_unit_id,
        }));
      },
      search: true,
      getSearchParams: (keywords: any) => ({ keyword: keywords }),
    },
    convertValue: (value: number, item: any) => ({
      [item.name]: [value],
    }),
  },
  machine_status: {
    name: 'machine_status',
    title: '三方审核',
    type: 'select',
    config: {
      data: [],
    },
  },
  manual_status: {
    name: 'manual_status',
    title: '人工审核',
    type: 'select',
    config: {
      data: [],
    },
  },
  machine_audit_status: {
    name: 'machine_audit_status',
    title: '三方审核结果',
    type: 'select',
    config: {
      data: [],
    },
  },
  manual_audit_status: {
    name: 'manual_audit_status',
    title: '人工审核结果',
    type: 'select',
    defaultValue: 2,
    config: {
      data: [],
    },
  },
  creative_audit_mdm_id: {
    title: '客户名称',
    name: 'mdm_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择客户名称',
      fetchData: (params: any) => getAuditMdmList({
        ...params,
        page: 1,
        page_size: 50,
      }),
      convertData: (res: any) => {
        return (res?.data?.list || []).map((v: any) => ({
          label: `${v.mdm_name}(${v.mdm_id})`,
          value: v.mdm_id,
        }));
      },
      search: true,
      getSearchParams: (keywords: any) => (keywords ? { mdm_name_fuzzy: keywords } : {}),
    },
  },
  use_derive: {
    name: 'use_derive',
    title: '是否使用衍生',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择',
    },
  },
  is_fresh: {
    name: 'is_fresh',
    title: '是否是新鲜创意',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择',
    },
  },
  use_aigc: {
    name: 'use_aigc',
    title: '是否使用AIGC',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择',
    },
  },
  is_aid_for_aigc: {
    name: 'is_aid_for_aigc',
    title: '是否AIGC扶持类型',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择',
    },
  },
  resource_type: {
    name: 'resource_type',
    title: '素材类型',
    type: 'select',
    config: {
      data: [
        { value: 1, label: '图片' },
        { value: 2, label: '视频' },
      ],
    },
  },
  role_type: {
    name: 'user_role',
    title: '员工类型',
    type: 'select',
    defaultValue: 116,
    config: {
      data: [
        { value: 116, label: '设计师' },
        { value: 108, label: '优化师' },
      ],
    },
  },
  dynamic_creative_id_list: {
    name: 'dynamic_creative_id_list',
    title: '【3.0】创意ID',
    ...FILTER_TEMPLATE.numArray,
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.replace(/\s+/g, '').split(',')

        .filter((v: string) => v),
    }),
  },
  component_id: {
    name: 'component_id',
    title: '组件ID',
    type: 'search',
    config: {
      placeholder: '请输入组件ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  component_name: {
    name: 'component_name',
    title: '组件名称',
    type: 'search',
    config: {
      placeholder: '请输入组件名称',
    },
  },
  component_class: {
    name: 'component_class',
    title: '组件类型',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择组件类型',
    },
  },
  unit_id: {
    name: 'unit_id',
    title: '所属业务单元',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择所属业务单元',
      fetchData: (params: any) => getComponentUnitList({
        ...params,
        page: 1,
        page_size: 50,
      }),
      convertData: (res: any) => {
        return (res?.data?.list || []).map((v: any) => ({
          label: v.name ? `${v.name}(${v.unit_id})` : v.unit_id || '',
          value: v.unit_id,
        }));
      },
      search: true,
      getSearchParams: (keywords: any) => (isNaN(keywords) ? { unit_name: keywords } : { unit_id: keywords }),
    },
  },
  pre_audit_status: {
    name: 'pre_audit_status',
    title: '组件预审最终状态',
    type: 'select',
    config: {
      placeholder: '请选择组件预审最终状态',
      data: [
        { value: 1, label: '待审核' },
        { value: 2, label: '通过' },
        { value: 3, label: '拒绝' },
      ],
    },
  },
};
